import React, { useMemo } from "react";

interface ISectionViewResizeIndicatorProps {
  resizing: boolean;
  height: number;
}

export function SectionViewResizeIndicator(props: ISectionViewResizeIndicatorProps) {
  const { resizing, height } = props;

  const roundedHeight = useMemo(() => {
    return Math.round(height);
  }, [height]);

  return (
    <>
      {resizing && (
        <div className="website-builder-section-view-resize-indicator">
          <div>
            {roundedHeight}px
          </div>
        </div>
      )}
    </>
  );
}

